import { Service } from "typedi";
import { AgentRPCCommand } from "../../../../shared/RPC/AgentRPCCommand";
import { AgentRPCCommands } from "../../../../shared/RPC/AgentRPCCommands";

const LOCATION_TIMEOUT_MS = 10000;

@Service()
export class GetDeviceLocation implements AgentRPCCommand<"get.device.location"> {
    constructor(agentRPCCommands: AgentRPCCommands) {
        agentRPCCommands.register("get.device.location", this);
    }

    async run(highAccuracy: boolean): Promise<{ latitude: number; longitude: number }> {
        if (!navigator.geolocation) {
            throw new Error("Geolocation API not available");
        }
        return new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    resolve({
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude
                    });
                },
                (err) => reject(new Error(err.message)),
                { enableHighAccuracy: highAccuracy, timeout: LOCATION_TIMEOUT_MS }
            );
        });
    }
}
